<template>
    <small class="d-block text-center mt-5 mb-5">(No accessories added yet)</small>
</template>

<script>
export default {

}
</script>
